import PropTypes from 'prop-types';
import React from 'react';
import ButtonComponent from '../component/global/Button';
import ButtonGroupComponent from '../component/global/ButtonGroup';
import ItemList from '../component/global/ItemList';
import ItemListHeaderComponent from '../component/global/ItemListHeader';
import ItemListMenuComponent from '../component/global/ItemListMenu';
import LabelComponent from '../component/global/Label';
import LabelsComponent from '../component/global/Labels';
import PageHeaderComponent from '../component/global/PageHeader';
import PeopleComponent from '../component/global/People';
import TitleComponent from '../component/global/Title';
import TotalComponent from '../component/global/Total';
import TicketsComponent from '../component/salestrekker/Tickets';
import ContactsComponent from '../component/salestrekker/Contacts';

const Jobs = ({ icon, pageTitle, scope, data, prop, updated }) => {
  const header = (
    orderBy,
    isDescending,
    getOrderAndDirection,
    getIsOrdered,
    toggleBulkActions,
    countOfSelectedItems,
    shown,
    disableOrderAndDirection
  ) => (
    <ItemListHeaderComponent
      eventId="jobsListHeaderSort"
      toggleBulkActions={toggleBulkActions}
      getOrderAndDirection={getOrderAndDirection}
      getIsOrdered={getIsOrdered}
      isDescending={isDescending}
      disableOrderAndDirection={disableOrderAndDirection}
      columns={[
        { id: 'name', coerce: 'string', title: 'Name' },
        { id: 'description', coerce: 'string', title: 'Comments', isDefault: true },
        { id: 'absoluteDueDate', coerce: 'number', title: 'Due date', isDefault: true },
        { id: 'idLabels', coerce: 'string', title: 'Labels' },
        { id: 'idTicket', coerce: 'string', title: 'Assigned to Deal' },
        { id: 'idContact', coerce: 'string', title: 'Assigned to Contact' },
        { id: 'idAssignedTo', coerce: 'string', title: 'Assigned to User' }
      ]}>
      <ItemListMenuComponent>
        <TotalComponent
          prefix="Selected"
          shown={countOfSelectedItems}
          size={shown}
          type="Tasks"
        />
        <ButtonComponent
          id="jobsListHeaderComplete"
          icon="icon-task-list-check-2"
          toolTip="Complete task(s)"
        />
        <ButtonComponent
          id="jobsListHeaderInComplete"
          icon="icon-task-list-plain-1"
          toolTip="Un-complete task(s)"
        />
        <ButtonComponent id="jobsListHeaderDelete" icon="icon-bin" toolTip="Delete task(s)" />
      </ItemListMenuComponent>
    </ItemListHeaderComponent>
  );

  const body = (dataState, item, isSelected) => (
    <dl data-item-selected={isSelected}>
      <dt>
        <TitleComponent title={item.getName()} />
      </dt>
      <dd>{item.getExcerpt()}</dd>
      <dd>
        {item.getDueDate(scope?.Root?.CurrentTimeZone(), scope?.Root?.CurrentLocale())}
        {item.isJobDue(scope?.Root?.CurrentTimeZone()) && !item.isJobCompleted() && (
          <LabelComponent name="Due" type="warning" />
        )}
        {item.isJobOverdue(scope?.Root?.CurrentTimeZone()) && !item.isJobCompleted() && (
          <LabelComponent name="Overdue" type="error" />
        )}
      </dd>
      <dd>
        <LabelsComponent labels={dataState?.Labels?.getCollectionData()} ids={item.idLabels} />
      </dd>
      <dd>
        <TicketsComponent
          tickets={dataState?.Tickets?.getCollectionData()}
          ids={item.idTicket}
        />
      </dd>
      <dd>
        <ContactsComponent
          contacts={dataState?.Contacts?.getCollectionData()}
          ids={item.idContact}
        />
      </dd>
      <dd>
        <PeopleComponent
          people={dataState?.Accounts?.getCollectionData()}
          ids={item.idAssignedTo}
        />
      </dd>
      <ItemListMenuComponent>
        <ButtonComponent
          id="jobsListEdit"
          icon="icon-pencil-2"
          toolTip={`Edit ${item.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
        <ButtonComponent
          id="jobsListLabel"
          icon="icon-tags-edit"
          toolTip={`Edit label(s) for ${item.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
        {!item.isCompleted && (
          <ButtonComponent
            id="jobsListComplete"
            icon="icon-task-list-check-2"
            toolTip={`Complete ${item.getName()}`}
            toolTipPosition="left"
            clickButtonArgs={item}
          />
        )}
        {item.isCompleted && (
          <ButtonComponent
            id="jobsListInComplete"
            icon="icon-task-list-plain-1"
            toolTip={`Un-complete ${item.getName()}`}
            toolTipPosition="left"
            clickButtonArgs={item}
          />
        )}
        <ButtonComponent
          id="jobsListDelete"
          icon="icon-bin"
          toolTip={`Delete ${item.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
      </ItemListMenuComponent>
    </dl>
  );

  return (
    <>
      <PageHeaderComponent icon={icon} title={pageTitle}>
        <ButtonGroupComponent>
          <ButtonComponent id="jobsProgressView" title="Progress" icon="icon-loading-3" />
          <ButtonComponent id="jobsFiltersToggle" title="Filter" icon="icon-filter-1" />
          <ButtonComponent id="jobAddNew" title="Add new" icon="icon-add-square" />
        </ButtonGroupComponent>
      </PageHeaderComponent>
      <ItemList
        data={data}
        prop={prop}
        type={pageTitle}
        header={header}
        body={body}
        updated={updated}
      />
    </>
  );
};

Jobs.propTypes = {
  icon: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  scope: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  prop: PropTypes.string.isRequired,
  updated: PropTypes.string
};

Jobs.defaultProps = {
  updated: undefined
};

export default Jobs;
